<template>
  <header class="header">
    <!-- pc端header -->
    <div class="container">
      <el-row>
        <el-col class="hidden-lg-and-down" :xl="6">
          <div class="logo">
            <img src="@/assets/images/组 15.png" alt="" />
          </div>
        </el-col>
        <el-col :xs="18" :sm="18" :lg="20" :xl="15">
          <div class="navList">
            <span
              v-for="(item, index) in navList"
              :class="index == navIndex ? 'active' : ''"
              :key="index"
              @click="navClick(item, index)"
              >{{ item.name }}</span
            >
          </div>
        </el-col>
        <el-col :xs="6" :sm="3" :lg="4" :xl="3">
          <!-- 没有token显示登录注册 -->
          <div class="login" v-if="user == null">
            <span @click="toLogin">登录 | </span>
            <!-- <router-link to="/login" tag="span">登录</router-link> | -->
            <span @click="toReg">注册</span>
          </div>
          <!-- 有token显示用户名 -->
          <div v-else class="user" @click="toUser">
            欢迎你，{{ user.userName }}
          </div>
        </el-col>
      </el-row>
      <Dialog
        v-if="dialogFormVisible"
        :logOrReg="logOrReg"
        @sonEvent="sonEvent"
      />
      <!-- <el-dialog
        :show-close="showClo"
        width="30vw"
        top="25vh"
        :visible.sync="dialogFormVisible2"
      >
        <div class="box px-5">
          <div
            class="text-center mt-0 mb-3 text-hover-dark font-weight-bold font-lg"
            v-if="login"
          >
            账号密码登录
          </div>
          <div
            class="text-center mt-0 mb-3 text-hover-dark font-weight-bold font-lg"
            v-if="forget"
          >
            密码
          </div>
          <div
            class="text-center mt-0 mb-3 text-hover-dark font-weight-bold font-lg"
            v-if="reg"
          >
            注册
          </div> -->
      <!-- 账号密码登录 -->
      <!-- <el-form
            v-if="login"
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            class="login-form"
          >
            <el-form-item prop="phone">
              <el-input
                prefix-icon="el-icon-user-solid"
                v-model="loginForm.phone"
                type="number"
                auto-complete="off"
                placeholder="请输入账号"
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                prefix-icon="el-icon-lock"
                v-model="loginForm.password"
                type="password"
                auto-complete="off"
                placeholder="请输入密码"
                @keyup.enter.native="handleLogin"
              >
              </el-input> -->
      <!-- </el-form-item> -->
      <!-- <el-checkbox v-model="loginForm.rememberMe" style="margin: 0px 0px 25px 0px">记住密码</el-checkbox> -->
      <!-- <el-form-item class="mb-0" style="width: 100%">
              <el-button
                class="loginBtn"
                :loading="loading"
                style="width: 100%"
                @click.native.prevent="submitForm('loginForm')"
              >
                <span v-if="!loading">登 录</span>
                <span v-else>登 录 中...</span>
              </el-button>
            </el-form-item>
          </el-form> -->

      <!-- 注册 -->
      <!-- <el-form
            ref="regForm"
            :model="regForm"
            :rules="regRules"
            class="login-form"
            v-if="reg"
          >
            <el-form-item prop="phone">
              <el-input
                prefix-icon="el-icon-user-solid"
                v-model="regForm.phone"
                type="text"
                auto-complete="off"
                placeholder="请输入账号"
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="code">
              <div class="flex justify-between">
                <el-input
                  prefix-icon="el-icon-circle-check"
                  v-model="regForm.code"
                  auto-complete="off"
                  placeholder="验证码"
                  style="width: 50%"
                  @keyup.enter.native="handleLogin"
                >
                </el-input>
                <div class="login-code text-center" style="width: 30%">
                  <span
                    v-if="!showTime"
                    class="code-text font"
                    @click="handleGetCodeClick"
                    >获取验证码</span
                  >
                  <span v-else class="code-text font">{{
                    currentCountTime + "s"
                  }}</span> -->
      <!-- <img :src="codeUrl" @click="getCode" class="login-code-img" /> -->
      <!-- </div>
              </div>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                prefix-icon="el-icon-lock"
                v-model="regForm.password"
                type="password"
                auto-complete="off"
                placeholder="请输入密码"
                @keyup.enter.native="handleLogin"
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="password2">
              <el-input
                prefix-icon="el-icon-lock"
                v-model="regForm.password2"
                type="password"
                auto-complete="off"
                placeholder="请确认密码"
                @keyup.enter.native="handleLogin"
              >
              </el-input>
            </el-form-item>
            <el-form-item class="mb-0" style="width: 100%">
              <el-button
                class="loginBtn"
                :loading="loading"
                size="medium"
                style="width: 100%"
                @click.native.prevent="submitForm('regForm')"
              >
                <span v-if="!loading">注 册</span>
                <span v-else>注 册 中...</span>
              </el-button>
            </el-form-item>
          </el-form> -->

      <!-- 忘记密码 -->
      <!-- <el-form
            v-if="forget"
            ref="forgetForm"
            :model="forgetForm"
            :rules="forgetRules"
            class="login-form"
          >
            <el-form-item prop="username">
              <el-input
                prefix-icon="el-icon-user-solid"
                v-model="forgetForm.username"
                type="text"
                auto-complete="off"
                placeholder="请输入账号"
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input
                prefix-icon="el-icon-circle-check"
                v-model="forgetForm.code"
                auto-complete="off"
                placeholder="验证码"
                style="width: 63%"
                @keyup.enter.native="handleLogin"
              >
              </el-input>
              <div class="login-code"> -->
      <!-- <img :src="codeUrl" @click="getCode" class="login-code-img" /> -->
      <!-- </div>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                prefix-icon="el-icon-lock"
                v-model="forgetForm.password"
                type="password"
                auto-complete="off"
                placeholder="请输入密码"
                @keyup.enter.native="handleLogin"
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                prefix-icon="el-icon-lock"
                v-model="forgetForm.password"
                type="password"
                auto-complete="off"
                placeholder="请确认密码"
                @keyup.enter.native="handleLogin"
              >
              </el-input>
            </el-form-item>
            <el-form-item style="width: 100%">
              <el-button
                class="loginBtn"
                :loading="loading"
                size="medium"
                type="primary"
                style="width: 100%"
                @click.native.prevent="handleLogin"
              >
                <span v-if="!loading">登 录</span>
                <span v-else>登 录 中...</span>
              </el-button>
            </el-form-item>
          </el-form>
          <div class="flex flex-row justify-end align-center pb-5 pt-2">
            <p class="a forget mr-1" v-if="login" @click="goForget">忘记密码</p>
            <p class="a forget mr-1" v-if="login" @click="goForget">|</p>

            <p class="a reg" v-if="login" @click="goReg">注册</p>
            <p class="a login1" v-if="!login" @click="goLogin">去登录</p>
          </div>
        </div>
      </el-dialog> -->
    </div>
  </header>
</template>

<script>
import { getCreatorData, getUserData } from "@/api/user/user";
import { getCodeImg, login, sendCode, register } from "@/api/login/login";
import { Encrypt } from "@/utils/AES";
import { stayTime } from "@/api/creative/creative.js";
import Dialog from "../Dialog/index.vue";
export default {
  components: {
    Dialog,
  },
  watch: {
    $route(to, from) {
      // console.log(from.name); // 从哪来
      // console.log(to); // 到哪去
      if (to.name == "home") {
        this.navIndex = 0;
      }
      if (to.name == "digital" || to.name == "digitalDetails") {
        this.navIndex = 5;
      }
      if (to.name == "excellent" || to.name == "excellentDetails") {
        this.navIndex = 4;
      }
      if (to.name == "creative" || to.name == "creativeDetails") {
        this.navIndex = 3;
      }
      if (to.name == "ai") {
        this.navIndex = 6;
      }
      if (to.name == "copyright" || to.name == "copyrightDetails") {
        this.navIndex = 2;
      }
      if (to.name == "register") {
        this.navIndex = 1;
      }
      if (to.name == "digitalDetails" || to.name == "creativeDetails") {
        this.enterTime = new Date();
        console.log(this.enterTime);
      }
      if (from.name == "digitalDetails" || from.name == "creativeDetails") {
        this.outTime = new Date();
        console.log(this.outTime);
        this.stayTime = Math.floor(
          (this.outTime.getTime() - this.enterTime.getTime()) / 1000
        );
        console.log(this.stayTime);
        console.log(from);
        stayTime({
          title: from.query.itemName || from.query.digitalName,
          goodsId: from.query.itemId || from.query.digitalId,
          goodsTime: this.stayTime,
          goodsType: from.query.goodsType,
        }).then((res) => {
          console.log(res);
        });
      }
    },
  },
  name: "",
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        console.log(value);
        let reg = /^1[3-9]\d{9}$/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      }
    };
    var validatePwd = (rule, value, callback) => {
      console.log(value);
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 8 || value.length > 13) {
        callback(new Error("密码须是8～16位字符"));
      } else {
        callback();
      }
    };
    var validatePwd2 = (rule, value, callback) => {
      console.log(value);
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 8 || value.length > 13) {
        callback(new Error("密码须是8～16位字符"));
      } else {
        callback();
      }
    };
    var validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else if (value.length !== 6) {
        callback(new Error("验证码须是6位字符"));
      } else {
        callback();
      }
    };

    return {
      navList: [
        { name: "首页", path: "/home" },
        { name: "版权登记", path: "/register" },
        { name: "版权定制", path: "/copyright" },
        { name: "文创商城", path: "/creative" },
        { name: "优秀作品", path: "/excellent" },
        { name: "数字产品", path: "/digital" },
        { name: "AI绘画", path: "/ai" },
      ],
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      user: JSON.parse(sessionStorage.getItem("user")) || null,
      isLogin: sessionStorage.getItem("token") ? true : false,
      sendFlag: false,
      showClo: false,
      dialogFormVisible: false,
      // itemName: "",
      codeUrl: "",
      loading: false,
      // 登录
      loginForm: {
        phone: "",
        password: "",
      },
      login: true,

      // 忘记密码
      forgetForm: {},
      forgetRules: {},
      forget: false,
      // 注册
      regForm: {
        phone: "",
        password: "",
        password2: "",
        code: "",
      },
      regRules: {
        phone: [{ validator: validatePhone, trigger: "blur" }],
        password: [{ validator: validatePwd, trigger: "blur" }],
        password2: [{ validator: validatePwd2, trigger: "blur" }],
        code: [{ validator: validateCode, trigger: "blur" }],
      },
      reg: false,

      ruleForm: {
        pass: "",
        checkPass: "",
      },
      loginRules: {
        phone: [{ validator: validatePhone, trigger: "blur" }],
        password: [{ validator: validatePwd, trigger: "blur" }],
      },
      formLabelWidth: "120px",

      countTime: 60,
      currentCountTime: 0,
      showTime: false,
      timeId: null,
      codeClick: false,
      logOrReg: 1,
      enterTime: null,
      outTime: null,
      stayTime: null,
    };
  },
  created() {
    this.currentCountTime = this.countTime;
    if (this.$route.path == "/home") {
      this.navIndex = 0;
      sessionStorage.setItem("navIndex", 0);
    }
  },
  methods: {
    sonEvent() {
      console.log(1);
      this.dialogFormVisible = false;
    },
    navClick(item, index) {
      // console.log(this.$route.path);
      if (item.path == this.$route.path) {
        return;
      }
      if (this.isLogin) {
        if (item.name == "版权登记" || item.name == "版权定制") {
          getUserData().then((res) => {
            if (res.data.isCreator == null) {
              console.log(res.data.isCreator);
              // this.$message.info("您还不是创作者");
              this.$message({
                message: "您还不是创作者",
                type: "error",
                duration: 1000,
              });
              this.$router.push({
                name: "user",
                query: {
                  isBeCreator: true,
                },
              });
              return;
            }
            if (res.data.isCreator == 1) {
              console.log(res.data.isCreator);
              this.$message.info("创作者审批中");
              return;
            }
            if (res.data.isCreator == 2) {
              console.log(res.data.isCreator);
              this.$message.error("创作者审批已驳回");
              return;
            }
            if (res.data.isCreator == 0) {
              this.$router.push({ path: item.path });
              console.log(index);
              this.navIndex = index;
              sessionStorage.setItem("navIndex", index);
              return;
            }
          });
          // getCreatorData().then((res) => {});
        } else {
          this.$router.push({ path: item.path });
          console.log(index);
          this.navIndex = index;
          sessionStorage.setItem("navIndex", index);
          return;
        }
      } else {
        if (
          item.name == "AI绘画" ||
          item.name == "版权登记" ||
          item.name == "版权定制"
        ) {
          this.toLogin();
          return;
        }
        this.$router.push({ path: item.path });
        console.log(index);
        this.navIndex = index;
        sessionStorage.setItem("navIndex", index);
      }
    },
    toUser() {
      if (this.$route.name == "user") {
        return;
      }
      this.$router.push({ name: "user" });
      this.navIndex = -1;
      sessionStorage.setItem("navIndex", this.navIndex);
    },

    submitForm(formName) {
      console.log(formName);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          if (formName == "loginForm") {
            this.handleLogin();
          } else if (formName == "regForm") {
            this.handleReg();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    toLogin() {
      this.logOrReg = 1;
      this.dialogFormVisible = true;
      this.goLogin();
    },
    toReg() {
      this.logOrReg = 2;
      this.dialogFormVisible = true;
      this.goReg();
    },
    //登录
    handleLogin() {
      let data = {
        phone: this.loginForm.phone,
        password: Encrypt(this.loginForm.password),
      };
      login(data)
        .then((data) => {
          if (data.code == 200) {
            let token = data.data.token.access_token;
            // this.$store.commit("setToken", token);
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("user", JSON.stringify(data.data.user));
            // 登录成跳转页面
            this.$message({
              message: "登录成功",
              type: "success",
            });
            setTimeout(() => {
              this.loading = false;
              this.dialogFormVisible = false;
              this.user = JSON.parse(sessionStorage.getItem("user"));
              this.$router.go(0);
            }, 1000);
          }
        })

        .finally((res) => {
          setTimeout(() => {
            this.loading = false;
            this.sendFlag = false;
          }, 1000);
        });
    },
    goForget() {
      this.forget = true;
      this.login = false;
      this.reg = false;
    },
    goReg() {
      this.login = false;
      this.forget = false;
      this.reg = true;
    },
    goLogin() {
      this.login = true;
      this.forget = false;
      this.reg = false;
    },

    // 注册
    handleGetCodeClick() {
      if (this.regForm.phone == "") {
        return this.$message("请输入手机号码");
      }
      if (this.sendFlag) {
        this.$message("发送中...");
        return;
      }
      this.sendFlag = true;
      sendCode({
        phone: this.regForm.phone,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message(res.msg);
          }
          this.$message("发送成功");
          this.showTime = true;
          this.codeClick = true;
          if (this.showTime && this.currentCountTime !== this.countTime) return;
          this.currentCountTime;
          this.timeId = setInterval(() => {
            if (this.currentCountTime <= 0) {
              this.currentCountTime = this.countTime;
              this.showTime = false;
              clearInterval(this.timeId);
            }
            this.currentCountTime--;
          }, 1000);
        })
        .catch((res) => {
          setTimeout(() => {
            this.sendFlag = false;
          }, 1000);
        })
        .finally((res) => {
          setTimeout(() => {
            this.loading = false;
            this.sendFlag = false;
          }, 1000);
        });
    },

    handleReg() {
      let data = {
        phone: this.regForm.phone,
        password: Encrypt(this.regForm.password),
        smsCode: this.regForm.code,
      };
      console.log(data);
      register(data)
        .then((data) => {
          if (data.code == 200) {
            // 登录成跳转页面
            this.$message({
              message: "注册成功",
              type: "success",
            });
            setTimeout(() => {
              this.loading = false;
              this.goLogin();
            }, 1000);
          }
        })
        .catch((res) => {
          setTimeout(() => {
            this.sendFlag = false;
          }, 1000);
        })
        .finally((res) => {
          setTimeout(() => {
            this.loading = false;
            this.sendFlag = false;
          }, 1000);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  // position: fixed;
  // top: 0;

  .container {
    background: rgba(234, 41, 22);
    box-sizing: border-box;
    max-width: 1920px;
    width: 100%;
    height: 100%;
    max-height: 80px;
    margin: 0 auto;
    padding: 24px 44px;

    .logo {
      width: 100%;
      max-width: 362px;
      height: 31px;
      // float: left;

      img {
        width: 100%;
        height: 100%;
        vertical-align: top;
      }
    }

    .navList {
      // float: left;
      line-height: 31px;
      // margin-left: 62px;
      span {
        height: 16px;
        line-height: 16px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        text-align: center;
        color: #fff;
        padding: 6px 20px 6px 18px;
        margin-right: 20px;
        cursor: pointer;
        // text-decoration: none;
      }
      a {
        height: 16px;
        line-height: 16px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        text-align: center;
        color: #fff;
        padding: 6px 20px 6px 18px;
        margin-right: 30px;
        cursor: pointer;
        text-decoration: none;
        // &.router-link-exact-active {
        //   background: white;
        //   color: #ec2c19;
        //   border-radius: 31px;
        // }
      }
      .active {
        background: white;
        color: #ec2c19;
        border-radius: 31px;
      }
      .active {
        a {
          background: white;
          color: #ec2c19;
          border-radius: 31px;
        }
      }

      a:hover {
        background: white;
        color: #ec2c19;
        border-radius: 31px;
      }
      span:hover {
        background: white;
        color: #ec2c19;
        border-radius: 31px;
      }
    }

    .login {
      // float: right;
      // width: 160px;
      text-align: center;
      height: 31px;
      font-size: 16px;
      line-height: 31px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .container2 {
    background-color: #ec2c19;
    width: 100%;
    // height: 100%;
    // max-height: 40px;
    color: #fff;

    .list {
      p {
        list-style: none;
        text-align: center;

        a {
          color: #fff;
          text-decoration: none;
        }
      }
    }
  }
}

.user {
  text-align: center;
  height: 31px;
  font-size: 16px;
  line-height: 31px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.loginBtn {
  border-radius: 50px;
  height: 46px;
  background: #fd412f;
  color: #fff;
}
.login-code {
  border-radius: 50px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
::v-deep .el-dialog__body {
  padding: 0 20px !important;
}
::v-deep .el-dialog {
  border-radius: 30px !important;
}
::v-deep .el-button:active {
  color: #db837b;
  border-color: #d82c1c;
}

::v-deep .el-input__inner {
  border-radius: 50px;
}
</style>
